import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { DLTextField, PrimaryButton } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllBrandsTable from './Table';
import NewBrandModal from '../../Modals/Brand/NewBrandModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllBrandsView extends Component {
    
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            newModal: false,
            brands: [],
            searchValue: '',
        };

        this.brandQueryObject = {
            sort: 'name,id',
            search: undefined,
            page: 1,
            limit: 30,
        };
    }

    componentDidMount() {
        this.loadBrands();
    }

    updateSearch = ( e, { value } ) => {
        this.setState( { searchValue: value } );
    }
    
    onSearchKeyDown = ( e ) => {
        if( e.keyCode == 13 ) {
            e.preventDefault();
            this.brandQueryObject.search = this.state.searchValue || undefined;
            this.brandQueryObject.page = 1;
            this.setState( {
                fetching: true,
                brands: [],
            } );
            this.loadBrands();
        }
    }

    onColumnSort = ( value ) => {
        if( this.brandQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.brandQueryObject.sort = value;
        this.brandQueryObject.page = 1;
        this.setState( {
            fetching: true,
            brands: [],
        } );
        this.loadBrands();
    }

    loadBrands = () => {
        return this.props.getBrands( this.brandQueryObject )
        .then( ( brands ) => {
            this.brandQueryObject.page++;
            this.setState( ( prevState ) => {
                prevState.fetching = false;
                prevState.brands = prevState.brands.concat( brands );
                return prevState;
            } );
            return brands;
        } );
    }

    brandUpdated = ( index, brand ) => {
        this.setState( ( altState ) => {
            if( brand !== null ) {
                altState.brands[ index ] = brand;
            } else {
                altState.brands.splice( index, 1 );
            }
            altState.brands = altState.brands.slice( 0 );
            return altState;
        } );
    }

    openNewModal = () => {
        this.setState( { newModal: true } );
    }

    onNewModalClose = () => {
        this.setState( { newModal: false } );
    }

    onNewModalSubmit = ( newBrand ) => {
        this.setState( ( altState ) => {
            altState.brands.unshift( newBrand );
            altState.brands = altState.brands.slice( 0 );
            altState.newModal = false;
            return altState;
        } );
    }

    render() {
        const { fetching, brands, searchValue } = this.state;

        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>Brands</h2>
                    <div className={ style.controls }>
                        <DLTextField className={ style.searchBar }
                        placeholder='Search'
                        value={ searchValue }
                        onChange={ this.updateSearch }
                        onKeyDown={ this.onSearchKeyDown }
                        noError />
                        <PrimaryButton
                        label='+ Create Brand'
                        style={ { width: '150px' } }
                        onClick={ this.openNewModal } />
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/brand' className={ style.tabOption }
                        data-active={ true }>View All</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allBrand }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllBrandsTable
                            brands={ brands }
                            loadMore={ this.loadbrands }
                            currentSort={ this.brandQueryObject.sort }
                            onColumnSort={ this.onColumnSort }
                            onBrandUpdated={ this.brandUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
                { this.state.newModal &&
                    <NewBrandModal closeModal={ this.onNewModalClose }
                    onSubmit={ this.onNewModalSubmit }/>
                }
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getBrands: ( queryObject ) => {
            return dAPI.get( '/admin/brands', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllBrandsView );
